import { gql } from '@apollo/client';

export const DOCUMENT_TYPE_PROPERTIES_LIST_QUERY = gql`
  query documentTypeProperties($documentTypeId: Int!, $pager: PagerInputNew, $filters: DocumentTypePropertiesFilterInput) {
    documentTypeProperties(documentTypeId: $documentTypeId, pager: $pager, filters: $filters) {
      total
      values {
        documentTypeId
        propertyId
        propertyTypeName
        mandatory
        defaultValue
        mainProperty
        implicit
        orderNo
        propertyCode
        propertyName
        propertyTypeId
      }
    }
  }
`;

export const DOCUMENT_TYPE_PROPERTIES_LIST_FILTERS_QUERY = gql`
  {
    documentTypePropertiesListFilters @client {
      fullTextFilter {
        value
      }
      documentTypeId {
        value
        type
      }
      propertyCode {
        value
      }
      propertyName {
        value
      }
      mandatory {
        value
        type
      }
    }
  }
`;
